import { Box, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { ResponsiveContainer, ComposedChart, LineChart, Bar, Line, ReferenceLine, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList, BarChart } from 'recharts';
import ResponsiveLegend from "utils/ResponsiveLegendChart";
import { formateMonthName } from "utils/formats";

export default function DespesaChart({ despesaData }) {

    const [chartAndTableData, setChartAndTableData] = React.useState([]);
    const { getLegendPosition, windowWidth } = ResponsiveLegend();

    useEffect(() => {
        if (despesaData && despesaData.length > 0) {
            let mappedData = despesaData.map((data) => ({
                name: formateMonthName(data.mesAno),
                despesaPessoalPdv: data.despesaPessoalPdv,
                despesaOcupacaoPdv: data.despesaOcupacaoPdv,
                despesaFinanceiraPdv: data.despesaFinanceiraPdv,
                despesaEstruturalPdv: data.despesaEstruturalPdv,
                despesaPessoalPercentual: data.percentualDespesaPessoal,
                despesaOcupacaoPercentual: data.percentualDespesaOcupacao,
                despesaFinanceiraPercentual: data.percentualDespesaFinanceira,
                despesaEstruturalPercentual: data.percentualDespesaEstrutural,
                despesaPessoal: data.pessoal,
                despesaOcupacao: data.ocupacao,
                despesaEstrutural: data.estrutural,
                despesaFinanceira: data.financeira
            }));
            setChartAndTableData(mappedData);
        }
    }, [despesaData]);

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            const despesaEstruturalPercentual = `${new Intl.NumberFormat('pt').format(data.despesaEstruturalPercentual)}%`
            const despesaFinanceiraPercentual = `${new Intl.NumberFormat('pt').format(data.despesaFinanceiraPercentual)}%`
            const despesaOcupacaoPercentual = `${new Intl.NumberFormat('pt').format(data.despesaOcupacaoPercentual)}%`
            const despesaPessoalPercentual = `${new Intl.NumberFormat('pt').format(data.despesaPessoalPercentual)}%`
            const despesaPessoalPdv = `R$ ${data.despesaPessoalPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const despesaOcupacaoPdv = `R$ ${data.despesaOcupacaoPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const despesaFinanceiraPdv = `R$ ${data.despesaFinanceiraPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const despesaEstruturalPdv = `R$ ${data.despesaEstruturalPdv.toLocaleString('pt-BR').split(',')[0]}`;
            return (
                <div className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc' }}>
                    <p>{data.name}</p>
                    <p> ESTRUTURAL %: {despesaEstruturalPercentual}</p>
                    <p> FINANCEIRA %: {despesaFinanceiraPercentual}</p>
                    <p> OCUPAÇÃO %: {despesaOcupacaoPercentual}</p>
                    <p> PESSOAL %: {despesaPessoalPercentual}</p>
                    <p> PESSOAL/PDV: {despesaPessoalPdv}</p>
                    <p> OCUPAÇÃO/PDV: {despesaOcupacaoPdv}</p>
                    <p> FINANCEIRA/PDV: {despesaFinanceiraPdv}</p>
                    <p> ESTRUTURAL/PDV: {despesaEstruturalPdv}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <div>
            <ResponsiveContainer width='99%' height={400}>
                <ComposedChart
                    width={1200}
                    height={400}
                    data={chartAndTableData}
                    margin={{
                        top: 20,
                        right: 30,
                        left: 5,
                        bottom: 10
                    }}
                >
                    <XAxis dataKey="name" stroke="#000" axisLine={false} tickLine={false} style={{ fontWeight: 'bold' }} />
                    <YAxis hide />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend
                        align={windowWidth > 600 ? 'left' : 'center'}
                        layout={windowWidth > 600 ? 'vertical' : 'horizontal'}
                        iconSize={10}
                        wrapperStyle={(windowWidth > 600) ? { ...getLegendPosition(),  minWidth: '140px', width: '140px',maxWidth: '140px' } : { ...getLegendPosition() }}
                        formatter={(value, entry) => <span style={{ color: '#000', fontSize: '10px' }}>{value}</span>}
                        payload={[
                            { value: ' ESTRUTURAL %', type: "rect", color: "#edd9da", },
                            { value: ' FINANCEIRA %', type: "rect", color: "#f5ecdb" },
                            { value: ' OCUPAÇÃO %', type: "rect", color: "#d9ebdf" },
                            { value: ' PESSOAL %', type: "rect", color: "#e0e4ed" },
                            { value: ' PESSOAL/PDV', type: "line", color: "#5e83ad" },
                            { value: ' OCUPAÇÃO/PDV', type: "line", color: "#42a76f" },
                            { value: ' FINANCEIRA/PDV', type: "line", color: "#ba7909" },
                            { value: ' ESTRUTURAL/PDV', type: "line", color: "#7e1b1e" },
                        ]}
                    />
                    <Bar
                        dataKey="despesaPessoalPercentual"
                        name=" PESSOAL %"
                        fill="#e0e4ed"
                        stackId="123"
                    />
                    <Bar
                        dataKey="despesaOcupacaoPercentual"
                        name=" OCUPAÇÃO %"
                        fill="#d9ebdf"
                        stackId="123"
                    />
                    <Bar
                        dataKey="despesaFinanceiraPercentual"
                        name=" FINANCEIRA %"
                        fill="#f5ecdb"
                        stackId="123"
                    />
                    <Bar
                        dataKey="despesaEstruturalPercentual"
                        name=" ESTRUTURAL %"
                        fill="#edd9da"
                        stackId="123"
                    />
                    <Line type="monotone" dataKey="despesaPessoalPercentual" name=" PESSOAL/PDV" stroke="#5e83ad" dot={false}>
                        <LabelList
                            dataKey="despesaPessoalPdv"
                            fill="#5e83ad"
                            formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
                            fontSize="10px"
                            position="top"
                        />
                    </Line>
                    <Line type="monotone" dataKey="despesaOcupacaoPercentual" name=" OCUPAÇÃO/PDV" stroke="#42a76f" dot={false}>
                        <LabelList
                            dataKey="despesaOcupacaoPdv"
                            fill="#42a76f"
                            formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
                            fontSize="10px"
                            position="top"
                        />
                    </Line>
                    <Line type="monotone" dataKey="despesaFinanceiraPercentual" name=" FINANCEIRA/PDV" stroke="#ba7909" dot={false}>
                        <LabelList
                            dataKey="despesaFinanceiraPdv"
                            fill="#ba7909"
                            formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
                            fontSize="10px"
                            position="top"
                        />
                    </Line>
                    <Line type="monotone" dataKey="despesaEstruturalPercentual" name=" ESTRUTURAL/PDV" stroke="#7e1b1e" dot={false}>
                        <LabelList
                            dataKey="despesaEstruturalPdv"
                            fill="#7e1b1e"
                            formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
                            fontSize="10px"
                            position="top"
                        />
                    </Line>
                </ComposedChart>
            </ResponsiveContainer>
            <div style={{ marginRight: '40px' }}>
                <table
                    style={{
                        width: '100%',
                        borderTop: '1px solid #000',
                        borderBottom: '1px solid #000',
                        overflow: 'auto',
                        tableLayout: 'fixed'
                    }}>
                    <tbody>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>PESSOAL</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.despesaPessoal.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ border: '1px dotted #000' }}></tr>
                        <tr style={{ borderBottom: '1px solid #000', }}>
                            <td><i>(TOTAL%)</i></td>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {`${(item.despesaPessoalPercentual)}%`}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>OCUPAÇÃO</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.despesaOcupacao.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ border: '1px dotted #000' }}></tr>
                        <tr style={{ borderBottom: '1px solid #000', }}>
                            <td><i>(TOTAL%)</i></td>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {`${(item.despesaOcupacaoPercentual)}%`}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>ESTRUTURAL</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.despesaEstrutural.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ border: '1px dotted #000' }}></tr>
                        <tr style={{ borderBottom: '1px solid #000', }}>
                            <td><i>(TOTAL%)</i></td>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {`${(item.despesaEstruturalPercentual)}%`}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>FINANCEIRA</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.despesaFinanceira.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ border: '1px dotted #000' }}></tr>
                        <tr style={{ borderBottom: '1px solid #000', }}>
                            <td><i>(TOTAL%)</i></td>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {`${(item.despesaFinanceiraPercentual)}%`}
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}
